import { render, staticRenderFns } from "./servicesheader.vue?vue&type=template&id=50bde660&scoped=true"
import script from "./servicesheader.vue?vue&type=script&lang=js"
export * from "./servicesheader.vue?vue&type=script&lang=js"
import style0 from "./servicesheader.vue?vue&type=style&index=0&id=50bde660&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bde660",
  null
  
)

export default component.exports